import React, { ReactNode } from 'react';
import Paper from '@mui/material/Paper';
import { EmptyState } from '../components/ui/EmptyState';

type PagePlaceholderProps = {
  title: string;
  children?: ReactNode;
};

export function PagePlaceholder({ title, children }: PagePlaceholderProps) {
  return (
    <Paper className="card" component="section" elevation={0}>
      <EmptyState title={title} message={children ?? 'This route is ready for its React view.'} />
    </Paper>
  );
}
